import { render } from "./LoraDashboard.vue?vue&type=template&id=394f047f&scoped=true"
import script from "./LoraDashboard.vue?vue&type=script&lang=js"
export * from "./LoraDashboard.vue?vue&type=script&lang=js"

import "./LoraDashboard.vue?vue&type=style&index=0&id=394f047f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394f047f"]])

export default __exports__